var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DropDown',{attrs:{"items":_vm.roles,"selectedItem":_vm.currentRole,"position":_vm.position},on:{"change":function($event){return _vm.changeRole($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }